import type { SearchEntry } from "../../search/searchIndex.js";
import type { WorkspaceStore } from "../WorkspaceStore.js";

/**
 * Store-side dispatch for a picked search hit. Exported for tests and for
 * compositions that embed the modal with their own chrome.
 */
export function routeSearchPick(store: WorkspaceStore, entry: SearchEntry): void {
  const t = entry.target;
  switch (t.kind) {
    case "module":
      // Fresh main-view pick: select, fly the board, surface the nav row.
      store.applySelection({ moduleId: t.moduleKey, edgeId: null }, "board");
      store.emit({ type: "boardFly", moduleId: t.moduleKey });
      store.requestNavReveal(t.moduleKey);
      break;
    case "interface":
      // Select the owning module for board context, then the interface —
      // the details rail prioritises the interface over the module.
      store.applySelection({ moduleId: t.moduleKey, edgeId: null }, "board");
      store.select({ interfaceKey: t.qualifiedName });
      store.emit({ type: "boardFly", moduleId: t.moduleKey });
      break;
    case "process":
      // No process surface in the workbench yet — selecting it still feeds
      // any process-aware primitive a composition mounts.
      store.select({ activeProcessId: t.processKey });
      break;
    case "type":
      // Filtered out of the palette; unreachable via UI.
      break;
  }
}
